import {
  IonContent,
  IonPage,
  useIonViewDidEnter,
  useIonViewWillLeave,
} from '@ionic/react';
import React, { useState } from 'react';
import useEnhancedAuth from '../EnhancedAuth';
import './Default.css';
import { apiDeleteAccount } from '../services/api';
import AppPageHeader from '../components/AppPageHeader';
import { returnToMain, returnToMainLogout } from '../utils/nav';
import { useTranslation } from 'react-i18next';
import {
  getAppError,
  getUserMessageOrValidationError,
} from '../utils/messages';
import UnregisterForm from '../usecases/unregister/UnregisterForm';
import { useHistory } from 'react-router';
import { LoadingController } from '../utils/LoadingController';
import { useToaster } from '../hooks/useToaster';

const UnregisterPage: React.FC = () => {
  const auth = useEnhancedAuth();
  const [t] = useTranslation('global');
  const router = useHistory();
  const [present] = useToaster();

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const [confirm, setConfirm] = useState<boolean>(false);

  const [isPageActive, setIsPageActive] = useState(false);
  useIonViewDidEnter(() => {
    setIsPageActive(true);
  });
  useIonViewWillLeave(() => {
    setIsPageActive(false);
  });

  const getValidationError = () => {
    if (!confirm) {
      return t('unregister.errorconfirm');
    }
    return false;
  };

  const proceed = async () => {
    if (isSubmitting) {
      return;
    }

    const validationError = getValidationError();
    if (validationError !== false) {
      present(getAppError(validationError));
      return;
    }

    try {
      LoadingController.show();
      setIsSubmitting(true);
      await apiDeleteAccount(auth);
      //present(getAppSuccess(t('unregister.success')));
      auth.logout();
      returnToMainLogout(router);
    } catch (error) {
      console.error('Error deleting account ', error);
      const apiError = getUserMessageOrValidationError(error);
      if (typeof apiError === 'string') {
        present(getAppError(apiError));
      } else {
        present(getAppError(t('unregister.nosuccess')));
      }
    } finally {
      setIsSubmitting(false);
      LoadingController.hide();
    }
  };

  return (
    <IonPage id="account-page">
      <AppPageHeader
        isPageActive={isPageActive}
        back={() => returnToMain(router)}
        title={t('unregister.title')}
      ></AppPageHeader>
      <IonContent fullscreen className="ion-padding default-content">
        <UnregisterForm
          isValid={getValidationError() === false}
          proceed={proceed}
          confirm={confirm}
          setConfirm={setConfirm}
        ></UnregisterForm>
      </IonContent>
    </IonPage>
  );
};

export default UnregisterPage;
